import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-warning\"><defs><style type=\"text/css\">@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\r\n</style></defs><path d=\"M460.8 0h102.4v102.4H460.8zM113.8688 186.368l72.3968-72.3968L258.6624 186.368 186.2656 258.7648zM0 460.8h102.4v102.4H0zM921.6 460.8h102.4v102.4h-102.4zM765.3376 186.6752l72.3968-72.448 72.3968 72.448-72.3968 72.3968z\" p-id=\"3164\" /><path d=\"M870.4 512a358.4 358.4 0 0 0-716.8 0v409.6H0v102.4h1024v-102.4h-153.6zM460.8 307.2h102.4v358.4H460.8z m0 460.8h102.4v102.4H460.8z\" p-id=\"3165\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warning.svg
// module id = TcIt
// module chunks = 80